var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6591 12.1904L27.0989 0.305908L23.3281 3.95687L28.4146 8.82994C27.9536 8.80913 27.4926 8.79869 27.0315 8.79869L27.0254 8.79877C19.6286 8.89026 13.3478 11.3997 8.21243 16.3276C3.07621 21.2563 0.5 27.2443 0.5 34.264C0.5 37.4717 1.05719 40.4916 2.17491 43.3196C3.29091 46.1431 4.89223 48.7023 6.97627 50.9952L7.31486 51.3677L11.5315 47.3779L11.1947 47.0238C9.5307 45.2743 8.30713 43.2646 7.52144 40.9906C6.72882 38.6965 6.33532 36.455 6.33532 34.264C6.33532 28.8182 8.32497 24.1735 12.3219 20.3036C16.3172 16.4353 21.2118 14.4561 27.0352 14.3671C27.3998 14.3672 27.9333 14.3889 28.6412 14.4336C28.9253 14.4515 29.1928 14.473 29.4438 14.4979L23.2544 20.3544L27.099 24.0749L39.6591 12.1904Z",
    fill: "#0B0F5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3409 50.4215L35.9011 62.306L39.6719 58.655L34.5854 53.7819C35.0464 53.8028 35.5074 53.8132 35.9685 53.8132L35.9746 53.8131C43.3714 53.7216 49.6522 51.2122 54.7876 46.2843C59.9238 41.3556 62.5 35.3676 62.5 28.3478C62.5 25.1402 61.9428 22.1203 60.8251 19.2923C59.7091 16.4688 58.1078 13.9096 56.0237 11.6167L55.6851 11.2441L51.4685 15.234L51.8053 15.5881C53.4693 17.3376 54.6929 19.3473 55.4786 21.6213C56.2712 23.9154 56.6647 26.1569 56.6647 28.3478C56.6647 33.7937 54.675 38.4383 50.6781 42.3083C46.6828 46.1766 41.7883 48.1558 35.9648 48.2448C35.6002 48.2447 35.0667 48.223 34.3588 48.1783C34.0747 48.1604 33.8072 48.1389 33.5562 48.114L39.7456 42.2575L35.901 38.537L23.3409 50.4215Z",
    fill: "#256BE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/card2.603f9c916bb17c6a2ce12c8ff334f08c.svg";
export { ForwardRef as ReactComponent };